import React from "react";

const DmwfSection = () => {
  return (
    <div className="column-sections pb-20">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="column-content">
            <div class="service_style_two_title pb-3 text-left">
                  <h4>What We Discussed at DMWF</h4>
            </div>
              <p className="text-left black">At DMWF Europe, we explored how forward-looking teams can use renewal signals to sharpen GTM execution.
<br/>
             Specifically, how renewal timelines can be used to:

              </p>
              <div class="col-md-12 col-lg-6 text-left">
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Identify high-intent accounts before competitive noise peaks</h6>
              </div>
            </div>
            <div class="why-choose-icon " data-wow-delay=".6">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>Prioritize expansion and cross-sell opportunities with precision</h6>
              </div>
            </div>
            <div class="why-choose-icon" data-wow-delay=".7">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>Align sales and marketing around real buying windows</h6>
              </div>
            </div>
             <div class="why-choose-icon" data-wow-delay=".7">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>Reduce resource spend on late or misaligned outreach</h6>
              </div>
            </div>
            <p>Renewals aren’t a back-office metric anymore. They’re a frontline GTM signal.</p>
            {/* <div class="service_style_two_title pt-4 text-left">
                  <h6 className="w-100">One solution that sparked major interest: Next Tech Purchase®, our proprietary predictive engine that forecasts upcoming technology investments before traditional intent data can. For marketing teams, it means one thing:
                  </h6>
            </div>   */}
          
          </div>
            {/* <p className="text-left">One solution that sparked major interest: <a href="https://proplusdata.co/next-tech-purchase">Next Tech Purchase®</a> , our proprietary predictive engine that forecasts upcoming technology investments before traditional intent data can. For marketing teams, it means one thing:</p>
            <p className="text-left">A first-mover advantage on tech-buying accounts that are still off your radar.</p> */}
          <div class="service_style_two_title pt-4 text-left">
                  <h4>Why Renewal Intelligence Matters Now</h4>
            </div>
          <p className="text-left">Most GTM strategies still rely heavily on intent signals alone. Useful, but incomplete.
<br/> <a href="https://proplusdata.co/renewal-intelligence">Renewal Intelligence</a> empowers you with comprehensive account intelligence and renewal cycle insights that will help you map your forecast. By leveraging tailored outreach strategies informed by customer behavior and lifecycle trends, you can optimize opportunities for upselling and cross-selling, and foster enduring partnerships.
</p>
         
          

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DmwfSection;
